import {useSelector} from "react-redux";
import users from "../../../users";
import {useRef} from "react";
import './squadflixRowTitle.scss';

type Props = {
    title: React.ReactNode;
    icon?: React.ReactNode;
    forceDarkMode?: 'dark' | 'light';
    extraOptions?: React.ReactNode;

    // manage order
    showReorderControls?: boolean;
    order?: number;
    onMoveUp?: () => void;
    onMoveDown?: () => void;
    isLast?: boolean;
    isFirst?: boolean;
}

const SquadflixRowTitle = (props: Props) => {
    const {title, icon, forceDarkMode} = props;
    const darkMode = useSelector(users.selectors.isDarkMode);
    const isDarkMode = forceDarkMode ? (forceDarkMode === 'dark') : darkMode;
    const titleRef = useRef<HTMLDivElement>(null);

    const handleMoveDown = () => {
        if (props.onMoveDown) {
            props.onMoveDown();
        }
        requestAnimationFrame(() => {
            if (titleRef.current) {
                titleRef.current.scrollIntoView({behavior: "auto", block: "center", inline: "center"});
            }
        });
    }

    const handleMoveUp = () => {
        if (props.onMoveUp) {
            props.onMoveUp();
        }
        requestAnimationFrame(() => {
            if (titleRef.current) {
                titleRef.current.scrollIntoView({behavior: "auto", block: "center", inline: "center"});
            }
        });
    }

    return (
        <div ref={titleRef} style={{
            height: "27px",
            marginTop: "3px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "large",
            fontWeight: "500",
            color: isDarkMode ? "white" : "black",
        }} className="ps-1 mb-2">
            <div>
                {icon}
                <span
                    className="ps-1">{title}</span>
            </div>
            <div className="d-flex flex-row align-items-center gap-1">
                {!props.showReorderControls && props.extraOptions}
                {props.showReorderControls && !props.isLast && props.order && <button
                    className="squadflix-row-title__order-btn"
                    onClick={handleMoveDown}>
                    <i className="fa-solid fa-chevron-down"></i>
                </button>}
                {props.showReorderControls && !props.isFirst && props.order && <button
                    className="squadflix-row-title__order-btn"
                    onClick={handleMoveUp}>
                    <i className="fa-solid fa-chevron-up"></i>
                </button>}
            </div>
        </div>
    );
}

export default SquadflixRowTitle;
